import { add, sub } from 'date-fns'
import { Platform } from 'react-native'
import { useAppSelector } from '../state/hooks'
import { cloudFunction } from '../firebase/functions'

export default function useInjectOrderParams(checkoutData) {
	const { phoneNumber, prices, giftCard } = useAppSelector(state => state.checkout)
	const { couponCode, isDelivery } = useAppSelector(state => state.persisted)
	const { userLocation } = useAppSelector(state => state.user)

	const injectParameters = async (orderId, tipAmount?: number): Promise<void> => {
		const { cartPrep } = checkoutData

		let pickupDate = null
		if (isDelivery && cartPrep?.isScheduled) {
			pickupDate = sub(new Date(cartPrep?.deliveryTime), {
				minutes: cartPrep?.deliveryPrepTime - cartPrep?.longestPrepTime,
			}).toISOString()
		} else if (cartPrep?.isScheduled) {
			pickupDate = cartPrep?.pickupTime?.toISOString()
		} else {
			pickupDate = add(new Date(), { minutes: cartPrep?.longestPrepTime }).toISOString()
		}

		const result = await cloudFunction('v2_injectOrderParameters', {
			orgId: global.org,
			orderId,
			futureOrderParams: {
				couponCode: couponCode || '',
				giftCards: giftCard?.code ? [giftCard.code] : [],
				platform: Platform.OS === 'web' ? 'web' : global.pos ? 'pos' : 'kiosk',
				giftcardAmount: prices.redeemedGiftCard,
				restaurantTipAmount: tipAmount ?? prices.tip,
				driverTipAmount: 0,
				...(isDelivery && {
					orgId: global.org,
					pickupTime: pickupDate,
					customerAddress: userLocation.longAddress,
					customerPhone: phoneNumber,
					restaurantTipAmount: 0,
					driverTipAmount: prices.tip,
					isSandbox:
						checkoutData.loadedData[global.org].environment === 'sandbox' ||
						checkoutData.isTestMode,
				}),
			},
		})

		return result
	}

	return { injectParameters }
}
